import { cn } from "~/lib/utils";

 function Section({ children, ...props }) {
  return (
    <div className={props.className} {...props}>
      <div className="container mx-auto">
        {children}
      </div>
    </div>
  );
}

export { Section }
